"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonGroup = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
let ButtonGroup = class ButtonGroup extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.direction = 'row';
        this.justifyContent = 'flex-start';
        this.stretch = false;
    }
    render() {
        return (0, lit_1.html) `
      <slot></slot>
    `;
    }
};
ButtonGroup.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;
      gap: var(--space-2);
    }

    :host([direction='column']) {
      flex-direction: column;
    }

    ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('justify-content', shared_styles_1.justifyContentTokens))}

    :host([stretch]) ::slotted(*) {
      flex: 1;
      --button-width: 100%;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], ButtonGroup.prototype, "direction", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'justify-content', reflect: true })
], ButtonGroup.prototype, "justifyContent", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, reflect: true })
], ButtonGroup.prototype, "stretch", void 0);
ButtonGroup = __decorate([
    (0, decorators_js_1.customElement)('mm-button-group')
], ButtonGroup);
exports.ButtonGroup = ButtonGroup;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnV0dG9uLWdyb3VwLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiYnV0dG9uLWdyb3VwLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFzRDtBQUN0RCxxREFBMkQ7QUFFM0QsK0RBSW9DO0FBQ3BDLG1DQUE2QztBQUd0QyxJQUFNLFdBQVcsR0FBakIsTUFBTSxXQUFZLFNBQVEsZ0JBQVU7SUFBcEM7O1FBc0JzQyxjQUFTLEdBQWtCLEtBQUssQ0FBQTtRQUUzRSxtQkFBYyxHQUFtQixZQUFZLENBQUE7UUFDRCxZQUFPLEdBQUcsS0FBSyxDQUFBO0lBTzdELENBQUM7SUFMQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs7S0FFVixDQUFBO0lBQ0gsQ0FBQzs7QUE5Qk0sa0JBQU0sR0FBRyxJQUFBLFNBQUcsRUFBQTs7Ozs7Ozs7Ozs7Ozs7TUFjZixJQUFBLGVBQVMsRUFBQyxJQUFBLDJCQUFtQixFQUFDLGlCQUFpQixFQUFFLG9DQUFvQixDQUFDLENBQUM7Ozs7OztHQU0xRSxDQUFBO0FBQzBDO0lBQTFDLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDOzhDQUFpQztBQUUzRTtJQURDLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsU0FBUyxFQUFFLGlCQUFpQixFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsQ0FBQzttREFDM0I7QUFDRDtJQUEzQyxJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsT0FBTyxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsQ0FBQzs0Q0FBZ0I7QUF6QmhELFdBQVc7SUFEdkIsSUFBQSw2QkFBYSxFQUFDLGlCQUFpQixDQUFDO0dBQ3BCLFdBQVcsQ0FnQ3ZCO0FBaENZLGtDQUFXIn0=